// store/modalSlice.ts
import { sideKey } from '@/components/Common/Sides/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SideState {
  activeSide: string | null;
  sideData: any;
}

const initialState: SideState = {
  activeSide: null,
  sideData: null,
};

const sideSlice = createSlice({
  name: 'side',
  initialState,
  reducers: {
    showSide: (
      state,
      action: PayloadAction<{
        sideKey: sideKey;
        sideData?: any;
      }>
    ) => {
      state.activeSide = action.payload.sideKey;
      state.sideData = action.payload.sideData || null;
    },
    hideSide: (state) => {
      state.activeSide = null;
      state.sideData = null;
    },
  },
});

export const { showSide, hideSide } = sideSlice.actions;

export default sideSlice.reducer;
